$(window).load ->
	$aboutTimeline = $ '.about-timeline'
	return unless $aboutTimeline.length > 0

	$halfRound = $aboutTimeline.find '.half-round'
	halfRoundWidth = $halfRound.width()

	$halfRound = $aboutTimeline.find '.half-round'
	halfRoundWidth = $halfRound.width()

	$datesContainer = $aboutTimeline.find '.dates'
	$datesListItems = $datesContainer.find 'li'
	$datesLink = $datesListItems.find 'a'

	$timeline = $aboutTimeline.find '.timeline'
	$timelineChildrens = $timeline.find '> span'
	$timelineProgress = $timeline.find '.progress'

	
	$datesLink.on 'click', (e) ->
		e.preventDefault()

		$this = $ this
		$currentListItem = $this.parent()

		isActive = $currentListItem.is '.is-active'

		return if isActive

		$currentListItemIndex = $currentListItem.index()

		isLast = $currentListItemIndex > $timelineChildrens.length - 1
		$currentTimelineItemIndex = if isLast then $currentListItemIndex - 1 else $currentListItemIndex

		$currentTimelineItem = $timelineChildrens.eq $currentTimelineItemIndex

		$currentTimelineItemPositionLeft = $currentTimelineItem.position().left
		$currentTimelineItemoffsetLeft = $currentTimelineItem.offset().left

		$progressWidth = if isLast then $currentTimelineItemPositionLeft + $currentTimelineItem.width() else $currentTimelineItemPositionLeft
		$halfRoundPositionLeft = if isLast then $currentTimelineItemoffsetLeft + $currentTimelineItem.width() else $currentTimelineItemoffsetLeft

		$datesListItems.removeClass 'is-active'
		$currentListItem.addClass 'is-active'

		$timelineProgress.stop(true).animate width: $progressWidth
		$halfRound.stop(true).animate left: $halfRoundPositionLeft - halfRoundWidth / 2

	$datesLink.first().click()


/** WEBPACK FOOTER **
 ** ./assets/coffee/pages/about.coffee
 **/